import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ComponentFactoryResolver,
  ComponentRef,
  ElementRef,
  OnDestroy,
  OnInit,
  Type,
  ViewChild
} from '@angular/core';
import { Subject } from 'rxjs';
import { DialogConfig } from './dialog-config';
import {NavigationEnd, Router} from "@angular/router";
import { DialogRef } from './dialog-ref';
import { InsertionDirective } from './insertion.directive';
import { ResponsiveService } from '../../services/responsive.service';
import { Breakpoints } from '@angular/cdk/layout';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.css']
})
export class DialogComponent implements OnInit, AfterViewInit, OnDestroy {
  componentRef: ComponentRef<any>;
  @ViewChild('modalContainer') modalContainer!: ElementRef<HTMLDivElement>;
  @ViewChild(InsertionDirective)
  insertionPoint: InsertionDirective;

  _onClose = new Subject<any>();
  public onClose = this._onClose.asObservable();
  initialWidth: string;
  isTabletSizeScreen = false;
  childComponentType: Type<any>;

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private cd: ChangeDetectorRef,
    private dialogRef: DialogRef,
    public config: DialogConfig,
    private responsive: ResponsiveService,
    private router: Router,
  ) {
    router.events.subscribe((val) => {
      if(val instanceof NavigationEnd) {
        this.dialogRef.close();
      }
    });
  }


  onDialogClicked(event: MouseEvent) {
    event.stopPropagation();
  }

  ngOnInit(): void {
    if(this.config.data.style.width) {
      this.initialWidth = this.config.data.style.width;
    }
    this.responsive.checkScreenSizeDynamic([
      Breakpoints.XSmall,
      Breakpoints.Small, 
      Breakpoints.Medium
    ]).subscribe(
      state => {
        if(state.matches) {
          this.config.data.style.width = '95vw';
        } else {
          this.config.data.style.width = this.initialWidth;
        }
      }
    )
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.modalContainer.nativeElement.focus();
    });
    this.loadChildComponent(this.childComponentType);
    this.cd.detectChanges();
  }

  onOverlayClicked(evt: MouseEvent) {
    this.dialogRef.close();
  }



  loadChildComponent(componentType: Type<any>) {
    let componentFactory = this.componentFactoryResolver.resolveComponentFactory(componentType);

    let viewContainerRef = this.insertionPoint.viewContainerRef;
    viewContainerRef.clear();

    this.componentRef = viewContainerRef.createComponent(componentFactory);
  }

  ngOnDestroy() {
    if (this.componentRef) {
      this.componentRef.destroy();
    }
  }

  close() {
    // this._onClose.next(null);
    this.dialogRef.close({closeEvent : true });
  }
}
